/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * @module enervee_utils.product_sections
 */
function productReviewsDirective() {
    return {
        restrict: 'E',
        scope: {
            productCtrl: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: productReviewsController,
        template: require('./productReviewsView.html')
    };
}

productReviewsController.$inject = [
    '$scope',
    'ProductService',
    '$timeout',
    'UtilService',
    'CmsContentService'
];
function productReviewsController (
    $scope,
    ProductService,
    $timeout,
    UtilService,
    CmsContentService
) {

    this.$onInit = function () {
        var vm = this;

        vm.productDetailData = vm.productCtrl.productDetailData;

        vm.expertReviewsEnabled = UtilService.isFeatureEnabled("expert_reviews");

        CmsContentService.getMarketPlaceText('details_page:ratings_from_other_retailers', {}, vm.productDetailData.category.id).then(function(text) {
            vm.ratingsFromOtherRetailers = text;
        });
        CmsContentService.getMarketPlaceText('details_page:ratings_expert_reviews', {}, vm.productDetailData.category.id).then(function(text) {
            vm.ratingsExpertReviews = text;
        });

        vm.isProductReviewsHeaderProductSpecific = ProductService.getDetailsPageConfig('is_product_reviews_header_product_specific');

        // retailersRatings will get the ordered list of the retailer ratings
        ProductService.getRetailersRatings(vm.productDetailData.id).then(function(retailersRatings) {
            vm.retailersRatings = retailersRatings;
        });

        // expertReviews will get the ordered list of the expert reviews
        ProductService.getExpertReviews(vm.productDetailData.id).then(function(expertReviews) {
            vm.expertReviews = expertReviews;
        });
    }
}

module.exports = productReviewsDirective;
